import http from '@/utils/http'
import { ElMessage } from 'element-plus'
import { LOCAL_STORAGE_KEYS } from '@/constants'
import { logError } from '@/utils/logger'

const DEFAULT_PAGE_SIZE = 15

const initialState = () => ({
  pageSize: parseInt(localStorage.getItem(LOCAL_STORAGE_KEYS.RECORDS_PER_PAGE)) || DEFAULT_PAGE_SIZE,
  list: []
})

export const state = initialState()

export const mutations = {
  RESET (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  SET_LIST (state, list) {
    state.list = list
  },
  SET_PAGE_SIZE (state, size) {
    localStorage.setItem(LOCAL_STORAGE_KEYS.RECORDS_PER_PAGE, size)
    state.pageSize = size
  }
}

export const getters = {
  list: state => state.list,
  pageSize: state => state.pageSize,
  total: state => (state.list[0] && state.list[0].TotalCount) || 0
}

export const actions = {
  fetchDetails ({ commit, rootGetters }, {
    id,
    isSet = false
  }) {
    const url = isSet
      ? `${process.env.VUE_APP_API_URL}DAS/files/xmldatafile/${rootGetters['auth/token']}/${rootGetters['customers/customerGuid']}/${id}`
      : `${process.env.VUE_APP_API_URL}DAS/record/${rootGetters['auth/token']}/${rootGetters['customers/customerGuid']}/${id}`

    return http({
      url,
      timeout: 120000
    }).then(data => {
      if (!data) {
        ElMessage.error(`${isSet ? 'Set' : 'Record'} details not found`)
        throw new Error('Record details not found')
      }

      return data
    }).catch(e => {
      ElMessage.error(`Error loading ${isSet ? 'set' : 'record'} details`)

      throw e
    })
  },
  fetchRecords ({ commit, getters, rootGetters }, { jobId, page = 1, filter = {} }) {
    const data = {
      JobID: jobId,
      PageSize: getters.pageSize,
      PageStart: page,
      ParentsOnly: true,
      ...filter
    }

    if (filter.SearchText) {
      data.SearchText = `%${filter.SearchText}%`
    }

    if (!{}.hasOwnProperty.call(filter, 'RecordStatus')) {
      data.RecordStatus = -1
    }

    return http({
      method: 'post',
      url: `${process.env.VUE_APP_API_URL}DAS/data/records/search/${rootGetters['auth/token']}`,
      data
    }).then(list => {
      commit('SET_LIST', list)

      return list
    }).catch(e => {
      ElMessage.warning('Error loading job records')

      logError(e, { data }, 'jobRecords: error loading job records')

      throw e
    })
  },
  async updateStatuses ({ commit, rootGetters }, { newStatusId, useFilter = false, ids = [], filter = {}, jobId, callback }) {
    let request

    if (useFilter) {
      filter = { ...filter }

      if (!filter.RecordStatus && filter.RecordStatus !== 0) {
        filter.RecordStatus = -1
      }

      if (filter.SearchText) {
        filter.SearchText = `%${filter.SearchText}%`
      }

      request = http({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}DAS/records/statusbysearch/${rootGetters['auth/token']}/${newStatusId}/${rootGetters['customers/customerGuid']}`,
        data: {
          JobID: jobId,
          PageSize: 0,
          ...filter
        }
      })
    } else {
      request = http({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}DAS/records/statusbyid/${rootGetters['auth/token']}/${newStatusId}/${rootGetters['customers/customerGuid']}`,
        data: ids
      })
    }

    return request.then(async function (data) {
      if (callback) {
        await callback()
      }
      return data
    }).catch(e => {
      ElMessage.error('Error changing statuses')

      throw e
    })
  },
  fetchRecordChildren ({ getters, commit, rootGetters }, { parentId, jobId }) {
    return http({
      url: `${process.env.VUE_APP_API_URL}DAS/records/related/${rootGetters['auth/token']}/${jobId}/${parentId}`
    })
      .then(related => related.filter(item => item.ParentID === parentId))
      .catch(e => {
        ElMessage.error('Error fetching record children')

        throw e
      })
  },
  deleteRecord ({ rootGetters }, record) {
    return http({
      method: 'post',
      url: `${process.env.VUE_APP_API_URL}DAS/record/delete/${rootGetters['auth/token']}`,
      data: record,
      convertJson: false
    }).then(data => {
      ElMessage.success('job record deleted')
      return data
    }).catch(e => {
      ElMessage.error('Error deleting record')

      throw e
    })
  }
}
